"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
require("./LineDashField.css");
/**
 * LineDashField to edit dashes for LineSymbolizers
 */
var LineDashField = /** @class */ (function (_super) {
    __extends(LineDashField, _super);
    function LineDashField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onAddDash = function () {
            var _a = _this.props, onChange = _a.onChange, dashArray = _a.dashArray;
            // add a new dash (UI)
            var newDashArray = dashArray.slice();
            newDashArray.push(1);
            if (onChange) {
                onChange(newDashArray);
            }
        };
        _this.onRemoveDash = function () {
            var _a = _this.props, onChange = _a.onChange, dashArray = _a.dashArray;
            // remove last dash (UI)
            var newDashArray = dashArray.slice();
            newDashArray.splice(newDashArray.length - 1, 1);
            if (onChange) {
                onChange(newDashArray);
            }
        };
        return _this;
    }
    LineDashField.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, dashArray = _a.dashArray;
        return (React.createElement("div", { className: "editor-field linedash-field" },
            dashArray.map(function (dash, idx) { return React.createElement(antd_1.InputNumber, { key: idx, value: dash, min: 1, step: 1, style: { width: 55 }, onChange: function (value) {
                    // replace current dash value
                    var newDashArray = dashArray.slice();
                    newDashArray[idx] = value;
                    if (onChange) {
                        onChange(newDashArray);
                    }
                } }); }),
            React.createElement(antd_1.Button, { className: "gs-add-dash-button", icon: "plus", onClick: this.onAddDash }),
            React.createElement(antd_1.Button, { className: "gs-rm-dash-button", icon: "minus", onClick: this.onRemoveDash })));
    };
    LineDashField.defaultProps = {
        dashArray: []
    };
    return LineDashField;
}(React.Component));
exports.LineDashField = LineDashField;
exports.default = LineDashField;
//# sourceMappingURL=LineDashField.js.map